import {useEffect} from 'react';
import {map as mapRx, mergeAll} from 'rxjs/operators';
import useDevices from '../../../hooks/use-devices';
import useSocket from '../../../hooks/use-socket';

const useMapDevice = (state, dispatch, instance) => {
  const {devices: socketDevices} = useSocket();

  const {devices} = useDevices();

  useEffect(() => {
    if (state.instance && devices.list.length) {
      const {instance: map, deviceMap} = state;

      socketDevices
          .pipe(
              mergeAll(),
              mapRx((device) => {
                devices.updateDevice(device);
                return device;
              }),
          )
          .subscribe((device) => {
            map.updateDevice(deviceMap.get(+device.id));
          });
    }
  }, [state.instance, state.deviceMap]);

  return {};
};

export default useMapDevice;
